// src/hooks/useLabRecommendations.js
//
// The lab tests the Orders step can offer: the retests the system recommends
// for this patient (GET /patients/{id}/effective-panel — the same data
// LabTestSuggestionPicker reads) plus the Previu panels, as one searchable list.
//   status: 'loading' | 'ready' | 'error'   (an error still leaves the panels)
//   options: [{ name, reason }]   reason: STALE | NEVER_TESTED | PANEL | RECENT
//     RECENT = tested recently, so not recommended, but still searchable — a doctor
//     can reorder any marker (e.g. HbA1c after an abnormal result).
//   recommended: only the entries that came from the patient's report

import { useEffect, useState } from 'react';
import { effectivePanelAPI } from '../services/api';
import { PANEL_TIER_DISPLAY_NAMES } from '../utils/labTestReminders';

const OFFERED_PANELS = ['T1', 'T2', 'T3'];
export const PANEL_OPTIONS = OFFERED_PANELS.map(c => ({ name: PANEL_TIER_DISPLAY_NAMES[c], reason: 'PANEL' }));
export const REASON_LABEL = { STALE: 'Retest', NEVER_TESTED: 'Baseline', PANEL: 'Panel', RECENT: 'Recent' };

export default function useLabRecommendations(patientId) {
  const [state, setState] = useState({ status: 'loading', recommended: [], recent: [] });
  useEffect(() => {
    if (!patientId) return undefined;
    let cancelled = false;
    effectivePanelAPI.get(patientId)
      .then(res => {
        if (cancelled) return;
        const recs = Array.isArray(res.data?.recommendations) ? res.data.recommendations : [];
        const recommended = recs.filter(r => r.markerName).map(r => ({ name: r.markerName, reason: r.reason }));
        const taken = new Set(recommended.map(r => r.name.toLowerCase()));
        const fresh = Array.isArray(res.data?.fresh) ? res.data.fresh : [];
        const recent = fresh.filter(m => m.markerName && !taken.has(m.markerName.toLowerCase()))
          .map(m => ({ name: m.markerName, reason: 'RECENT' }));
        setState({ status: 'ready', recommended, recent });
      })
      .catch(() => { if (!cancelled) setState({ status: 'error', recommended: [], recent: [] }); });
    return () => { cancelled = true; };
  }, [patientId]);
  return { ...state, options: [...state.recommended, ...PANEL_OPTIONS, ...state.recent] };
}
